import { ApiClient } from "./apiClient";
import { fetchTableRows, buildDRQuery } from "./dataRetrievalRequest";
import { findTelemetryDashboard } from "../utils/dashboardUtils";
import { tracePanelRequest } from "../features/dashboard/panelRequestUtils";
import i18n, { normalizeLanguage } from "../i18n";

const dashboardRequestURL = "/panel/"
const dashboardPanelsRequestURL = "/dashboard/"
const dashboardDateFilterRequestURL = "/newDashboard/"
const dashboardFiltersRequestURL = "/dashboard/filters/"
const inFlightDashboardPanelRequests =
  window.__makemakeInFlightDashboardPanelRequests ||
  (window.__makemakeInFlightDashboardPanelRequests = new Map());

const getDashboardIdFromStore = (store) => {
  const state = store.getState();

  const isTelemetrySelected =
    state?.application?.navigation?.telemetry?.now === true;

  if (!isTelemetrySelected) {
    return null;
  }

  const telemetryDashboard = findTelemetryDashboard(
    state?.dashboard?.dashboards
  );

  return telemetryDashboard?.id ?? null;
};

const getActiveLanguage = () =>
  normalizeLanguage(i18n.resolvedLanguage || i18n.language);

export const dashboardDataRequest = async (panel, store, { filterConfig, filterValues, extra } = {}) => {
  const chartType = panel?.chart_type || panel?.type;
  const rawAggregationOp = panel?.aggregation_op ?? "";
  const isNoneAgg =
    rawAggregationOp === "none" ||
    rawAggregationOp === "NONE" ||
    rawAggregationOp === "None";

  const aggregationOp = isNoneAgg ? "" : rawAggregationOp;

  const independent = isNoneAgg ? "" : (panel?.aggregate_by || "");
  const dependent =
    (Array.isArray(panel?.y_columns) &&
      panel.y_columns.length > 0 &&
      panel.y_columns[0]?.column_name) ||
    "";

  if (panel?.data_table_id) {
    // TODO: REFACTOR. BAD CODE. Bloque entero repetido más abajo, no pueden ser todos casos especiales
    // un único fetch Table rows. Se van componiendo los argumentos, hasta al final hacer la llamada
    if (chartType === "table_chart") {
      const cols = [
        panel?.x_column_name,
        ...(Array.isArray(panel?.y_columns)
          ? panel.y_columns.map((c) => c?.column_name)
          : []),
      ].filter(Boolean);

      const uniqueCols = [...new Set(cols)];

      const nextExtra = {
        ...(extra || {}),
        columns: uniqueCols,
        sample_limit: String((extra && extra.sample_limit) || 1000),
      };

      tracePanelRequest({
        phase: "fetch-table-chart",
        panel,
        filterValues,
        extra: nextExtra,
      });

      return fetchTableRows(
        {
          tableId: panel.data_table_id,
          filterConfig: filterConfig || [],
          filterValues: filterValues || {},
          aggregateBy: "",
          metricOp: "",
          valueColumn: "",
          extra: nextExtra,
        },
        store
      );
    }

    const isMarkerOrCounter =
      chartType === "marker" || chartType === "counter_chart";
    
    if (chartType === "status_chart") {
      extra = { ...extra, fetch_last_only: true, last_only_loopback_seconds: 10 };
    }

    tracePanelRequest({
      phase: "fetch-data-retrieval",
      panel,
      filterValues,
      extra,
    });
    
    return fetchTableRows(
      {
        tableId: panel.data_table_id,
        filterConfig: filterConfig || [],
        filterValues: filterValues || {},
        aggregateBy: isMarkerOrCounter ? "": independent,              
          metricOp: aggregationOp,       
          valueColumn: isMarkerOrCounter ? independent : dependent,   
          extra,
        },
        store
      );
  }
  const params = new URLSearchParams();
  params.set("id", panel.id);
  params.set("type", chartType);

  const drParams = buildDRQuery(
    filterConfig || [],
    filterValues || {},
    independent,
    aggregationOp,
    dependent
  );
  drParams.forEach((v, k) => params.append(k, v));

  if (filterValues && Object.keys(filterValues).length > 0) {
    params.set("filters", JSON.stringify(filterValues));
  }

  return ApiClient.private(store).get(`${dashboardRequestURL}?${params.toString()}`);
};
export const dashboardPanelsRequest = async (store) => {
  const dashboardId = getDashboardIdFromStore(store);
  const requestKey = dashboardId
    ? `${dashboardPanelsRequestURL}?dashboard=${dashboardId}&language=${getActiveLanguage()}`
    : `${dashboardPanelsRequestURL}?language=${getActiveLanguage()}`;

  if (inFlightDashboardPanelRequests.has(requestKey)) {
    return inFlightDashboardPanelRequests.get(requestKey);
  }

  const request = ApiClient.private(store)
    .get(dashboardPanelsRequestURL, {
      params: dashboardId ? { dashboard: dashboardId } : {},
    })
    .finally(() => {
      inFlightDashboardPanelRequests.delete(requestKey);
    });

  inFlightDashboardPanelRequests.set(requestKey, request);
  return request;
};

export const dashboardDateFilterRequest = async (store, data) =>
    ApiClient.private(store)
        .post(`${dashboardDateFilterRequestURL}?start_date=${data.dates.start_date}&end_date=${data.dates.end_date}`);

export const dashboardFiltersRequest = async (store, dashboardId) =>
    ApiClient.private(store)
        .get(dashboardFiltersRequestURL, { params: { dashboard: dashboardId },
        });
